module.exports = __webpack_public_path__ + "static/media/Close.0f739e19.svg";